/* Shared enhancements for the information-page component. */
(() => {
  const root = document.querySelector('.ks-information');
  if (!root) return;

  root.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ks-chat-trigger]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const chat = document.querySelector('shopify-chat');
    if (typeof chat?.show !== 'function') return;
    try {
      chat.show();
      event.preventDefault();
    } catch {
      return;
    }
  });

  const policy = root.querySelector('.shopify-policy__body');
  if (policy) {
    policy.querySelectorAll('p, h2, h3').forEach((paragraph) => {
      if (!paragraph.textContent.trim() && !paragraph.querySelector('img, video, iframe, input, svg')) {
        paragraph.remove();
      }
    });
    const title = root.querySelector('h1');
    const repeatedTitle = policy.querySelector('h2');
    const normalizeTitle = (value) => value.toLocaleLowerCase('tr').replace(/\s+metni$/, '').trim();
    if (title && repeatedTitle && normalizeTitle(title.textContent) === normalizeTitle(repeatedTitle.textContent)) {
      repeatedTitle.remove();
    }
    if (!policy.querySelector('h2')) {
      policy.querySelectorAll('h3').forEach((oldHeading) => {
        const heading = document.createElement('h2');
        for (const attribute of oldHeading.attributes) heading.setAttribute(attribute.name, attribute.value);
        heading.append(...oldHeading.childNodes);
        oldHeading.replaceWith(heading);
      });
    }
    policy.querySelectorAll('p').forEach((paragraph) => {
      if (/^Son Güncelleme Tarihi:/i.test(paragraph.textContent.trim())) paragraph.classList.add('ks-meta');
    });
    const headings = [...policy.querySelectorAll('h2, h3')];
    if (policy.textContent.length > 2000 && headings.length >= 3) {
      const nav = document.createElement('nav');
      nav.className = 'ks-help-nav';
      nav.setAttribute('aria-label', 'Bu sayfadaki konular');
      const label = document.createElement('p');
      label.textContent = 'Bu sayfadaki konular';
      const list = document.createElement('ul');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `ks-policy-section-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim().replace(/:$/, '');
        item.append(link);
        list.append(item);
      });
      nav.append(label, list);
      const intro = policy.querySelector('p');
      if (intro) intro.after(nav);
      else policy.prepend(nav);
    }
  }

})();
